import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: snis
 * id 8A2FFEED-01B4-44C0-A82A-2E03D8C2A447
 * name camera-document
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/camera-document.svg
 * tags
 * - Photography 
 */
export const CameraDocumentIcon = createSvgIcon(<><path d="M21 7V22H3V20H19V7H14.72C14.38 7.6 13.74 8 13 8C13 9.11 12.1 10 11 10H8C6.9 10 6 9.1 6 8V4C6 2.9 6.9 2 8 2H11C12.1 2 13 2.9 13 4C13.74 4 14.38 4.41 14.72 5H19C20.11 5 21 5.89 21 7M6 15H13L11 11H8L6 15Z" /></>, 'CameraDocumentIcon');
export default CameraDocumentIcon